import Portfolio from "../Portfolio/Portfolio";

function Stories() {
  return <Portfolio canonicalPath="/portfolio" />;
}

export default Stories;
